module.exports = "<inbrit-registration [IsRegisteredByBackOfficeUser]=\"true\" [userRoleId]=\"roleId\"></inbrit-registration>"